import normalizeMaxValue from './normalizeMaxValue';

const getBarData = (normalizedData, maximum) =>
  normalizedData.map(datum => ({
    proportion: datum.value / normalizeMaxValue(maximum),
    tooltip: datum.label ? datum.label : null,
    color: datum.color ? datum.color : null,
  }));

export default getBarData;
